import i18next from "i18next";
import { toast } from "react-hot-toast";

/**
 * Same branching as ServiceAgreementNewReportSection (agreement detail sidebar).
 * @returns {{ kind: 'missing_type' } | { kind: 'link_report', report: object } | { kind: 'create_report', disabled: boolean } | { kind: 'create_order', disabled: boolean }}
 */
export function getServiceAgreementNextJobUi(item) {
  if (!item?.type || item.type.mission === undefined) {
    return { kind: "missing_type" };
  }
  const hasActive = Boolean(item?.active_report?.id);
  const hasCustomer = Boolean(item?.customer?.id);

  if (item.type.mission === true) {
    if (hasActive) {
      return { kind: "link_report", report: item.active_report };
    }
    return { kind: "create_report", disabled: !hasCustomer };
  }

  return { kind: "create_order", disabled: !hasCustomer || hasActive };
}

export function validateServiceAgreementCreateReport(item) {
  if (!item?.id) {
    toast.error(i18next.t("service.agreements.actions.err_no_agreement"));
    return false;
  }
  if (item?.active_report?.id) {
    toast.error(i18next.t("service.agreements.actions.err_active_report_report"));
    return false;
  }
  if (!item?.customer?.id) {
    toast.error(i18next.t("service.agreements.actions.err_no_customer_report"));
    return false;
  }
  return true;
}

export function validateServiceAgreementCreateOrder(item) {
  if (!item?.id) {
    toast.error(i18next.t("service.agreements.actions.err_no_agreement"));
    return false;
  }
  if (item?.active_report?.id) {
    toast.error(i18next.t("service.agreements.actions.err_active_report_order"));
    return false;
  }
  if (!item?.customer?.id) {
    toast.error(i18next.t("service.agreements.actions.err_no_customer_order"));
    return false;
  }
  return true;
}
